var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcons = function SvgIcons(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16 29.334c7.364 0 13.333-5.97 13.333-13.334S23.363 2.667 16 2.667 2.667 8.637 2.667 16 8.637 29.334 16 29.334",
    opacity: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16 15.84a3.173 3.173 0 1 0 0-6.347 3.173 3.173 0 0 0 0 6.347M19.453 21.373l-1.6-2.013c.44-.12.88-.28 1.294-.48a.99.99 0 0 0 .4-1.334 1.007 1.007 0 0 0-1.334-.426 4.97 4.97 0 0 1-4.426 0 1 1 0 0 0-1.347.44 1 1 0 0 0 .44 1.346c.4.2.827.36 1.253.467l-1.586 2.013a.994.994 0 0 0 .16 1.4.994.994 0 0 0 1.4-.16l1.88-2.373 1.88 2.373a.99.99 0 0 0 .786.374c.214 0 .44-.067.614-.214.453-.346.52-.973.186-1.413"
  })));
};
export default SvgIcons;